/* eslint-disable max-len */
import React from 'react';

export default function DocumentsIcon() {
  return (
    <svg className="svg-icon" width="15" height="20" viewBox="0 0 15 20">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path d="M1.73 19.692h11.54c.954 0 1.73-.776 1.73-1.73V5.769h-4.039c-.954 0-1.73-.776-1.73-1.73V0h-7.5C.776 0 0 .776 0 1.73v16.232c0 .954.776 1.73 1.73 1.73zM4.039 8.115h6.923a.577.577 0 110 1.154H4.038a.577.577 0 110-1.154zm0 2.308h6.923a.577.577 0 110 1.154H4.038a.577.577 0 110-1.154zm0 2.308h6.923a.577.577 0 110 1.154H4.038a.577.577 0 110-1.154zm0 2.308h4.616a.577.577 0 110 1.153H4.038a.577.577 0 110-1.153z" />
        </g>
      </g>
    </svg>
  );
}
